
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy-for-technician",
      function () {
        return require("private-next-pages/policy-for-technician/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy-for-technician"])
      });
    }
  